import * as React from 'react';

import {
  UitkMessagingCard,
  UitkMessagingCardImageLayout,
  UitkMessagingCardMedia,
  UitkMessagingCardSection
} from 'uitk-react-messaging-cards';
import { MessagingCardViewModel } from 'models';
import { UitkFigure } from 'uitk-react-images';

export interface UrgencyMessagingCardProps {
  className?: string;
  icon?: string;
  urgencyText?: string;
}
export interface UrgencySearchMessagingCardProps {
  model: MessagingCardViewModel;
}

export const UrgencyMessagingCard = ({ className, icon, urgencyText }: UrgencyMessagingCardProps) => {
  if (!urgencyText) {
    return null;
  }

  return (
    <UitkMessagingCard className={className} imageLayout={UitkMessagingCardImageLayout.LEFT}>
      {icon && (
        <UitkMessagingCardMedia>
          <UitkFigure ratio={UitkFigure.AspectRatio.R1_1} src={icon} />
        </UitkMessagingCardMedia>
      )}
      <UitkMessagingCardSection>
        <p className="uitk-type-300">{urgencyText}</p>
      </UitkMessagingCardSection>
    </UitkMessagingCard>
  );
};

export const UrgencySearchMessagingCard = ({ model }: UrgencySearchMessagingCardProps) => {
  if (!model) {
    return null;
  }

  const subtitleModel = model.subtitleModel;
  const subtitle = subtitleModel && subtitleModel.text;
  const icon = subtitleModel && subtitleModel.icon;

  return (
    <li className="listing uitk-cell xl-cell-1-1 l-cell-1-1 m-cell-1-1 s-cell-1-1" data-stid="urgency-messaging-card">
      <UrgencyMessagingCard urgencyText={subtitle} icon={icon} />
    </li>
  );
};
